import { PromoCard } from '../../../promo-card/PromoCard';
import { getDefaultData } from '../../data/resources/get-default-data';
import { ResourceLinks } from '../../data/resources/resource-links';
import { NavigationSubHeaderWithLinks } from '../NavigationSubHeaderWithLinks';
import { FlexColumnContainer } from '../NavigationSubHeaderWithLinks.style';
import {
  HStackContainer,
  NavigationLinkContainer,
} from '../NavigationSubMenu.style';
import { navigation } from '@exploration/cms-constants';
import { MDSHStack } from '@midwest/web/stacks';

export const ResourcesNavigationSubMenu = () => {
  const cmsData = getDefaultData();

  return (
    <HStackContainer>
      <NavigationLinkContainer>
        <MDSHStack>
          <FlexColumnContainer>
            <NavigationSubHeaderWithLinks
              header={
                cmsData?.text?.[
                  navigation.resources_navigation_links.resources_learn_title
                ]
              }
              links={ResourceLinks.learnLinks}
            />
            <NavigationSubHeaderWithLinks
              header={
                cmsData?.text?.[
                  navigation.resources_navigation_links.resources_get_help_title
                ]
              }
              links={ResourceLinks.getHelpLinks}
            />
          </FlexColumnContainer>
        </MDSHStack>
      </NavigationLinkContainer>
      <PromoCard
        title={ResourceLinks.promoCard.title}
        description={ResourceLinks.promoCard.description}
        callToAction={{
          label: ResourceLinks.promoCard.callToAction.label,
          url: ResourceLinks.promoCard.callToAction.url,
        }}
      />
    </HStackContainer>
  );
};
